<template>
  <div class="img-list">
    <div
      class="imgs"
      v-for="(item, index) in imgList"
      :key="index"
      @click="emitAddImg(index)"
    >
      <input
        type="file"
        ref="imgFile"
        @change="addImg($event, index, item, 'iconFile')"
        accept="image/png, image/jpg, image/jpeg"
        class="file"
      />
      <div v-show="!item.imageUrl" class="file-info">
        <i class="el-icon-edit el-icon-plus"></i>
        <span>{{ item.imgName }}</span>
      </div>
      <img :src="item.imageUrl" />
      <el-button
        v-show="item.imageUrl && item.sequence !== 1"
        type="text"
        @click.stop="delImg(item,index)"
        class="del-btn"
        >删除</el-button>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  props: {
    type: {
      type: Number,
      default: 0,
    },
    bookPicPOList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      imgList: [
        {
          imgName: "封面",
          sequence: 1,
        },
        {
          imgName: "目录1",
          sequence: 2,
        },
        {
          imgName: "目录2",
          sequence: 3,
        },
        {
          imgName: "目录3",
          sequence: 4,
        },
        {
          imgName: "目录4",
          sequence: 5,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    init() {
      this.imgList = [
        {
          imgName: "封面",
          sequence: 1,
        },
        {
          imgName: "目录1",
          sequence: 2,
        },
        {
          imgName: "目录2",
          sequence: 3,
        },
        {
          imgName: "目录3",
          sequence: 4,
        },
        {
          imgName: "目录4",
          sequence: 5,
        },
      ];
    },
    delImg(item,index) {
      this.$emit("on-del-img", item,this.$refs.imgFile[index]);
    },
    emitAddImg(index) {
        $(".imgs .file")[index].value=null;
      $(".imgs .file")[index].click();
    },
    addImg(event, index, item) {
        console.log(event.target.files[0].size)
      if (event.target.files[0].size > (2 * 1024*1024)) {
        this.$message.error("图片不能大于2M");
        return
      }
      let imgObj = {
        file: event,
        index: index + 1,
        item: item,
      };
      this.$emit("on-add-img", imgObj);
    },
  },
  watch: {
    bookPicPOList: {
      handler(val) {
        // console.log(this.type,val,"this.type")
        this.init();
        if (val.length > 0) {
          this.imgList = this.imgList.map((item, index) => {
            let node = (val || {}).find((img) => {
              if (img) {
                return img.sequence - 1 === index;
              }
            });
            // console.log(node, "node");
            return { ...node, ...item };
          });
          // console.log(val, "val");
          // console.log(this.imgList, "this.imgList");
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
.img-list {
  display: flex;
  .imgs {
    width: 82px;
    height: 112px;
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-right: 20px;
    flex-direction: column;
    cursor: pointer;
    img {
      width: 100%;
    }
    .file-info {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex-direction: column;
    }
    .del-btn {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    input {
      display: none;
    }
    .el-icon-plus {
      font-size: 20px;
    }
  }
}
</style>
